// extracted by mini-css-extract-plugin
export default {"container":"MainPanel_container__p36DB"};